
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AlertService } from '../../../../services/alert.service';
import { Org } from '../../../../models/org.model';


@Component({
    selector: 'create-edit-org-modal',
    template: require('./create-edit-org-modal.component.html'),
    styles: [require('./create-edit-org-modal.component.css')]
})
export class CreateEditOrgModalComponent {
    currentOrg: Org;
    isCreatNew: boolean;
    constructor(private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditOrgModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.isCreatNew = (data.currentOrg.orgId == undefined);
        this.currentOrg = data.currentOrg;

    }

    ok() {
        if (!this.isCreatNew) {
            
            this.apiService.updateOrg(this.currentOrg).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update Org successfully");
                }
            });
        } else {
            this.apiService.createOrg(this.currentOrg).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Create Org successfully");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/orgs/create-edit-org-modal/create-edit-org-modal.component.ts